import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMedalStandingsItem } from '@App/types';
import { RootState } from '@App/store';

import medalStandingsApi from '@App/services/medalStandings/medalStandingsApi';
import { pollingSucceeded, pollingFailed } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';

import { pollingErrorHandlerSlice } from '@Features/errorHandler/polling/pollingErrorHandlerSlice';

export interface IMedalStandingsListState {
  changeTimestamp: number; // Tohle trigeruje mount/unmout pooling kontejneru, tak aby se forsnul reload při znovu kliku (jinak se vysypal state)
  dataLoaded: boolean;
  isFetching: boolean;
  error: any;
  data: IMedalStandingsItem[];
}

const initialState: IMedalStandingsListState = {
  changeTimestamp: 0,
  dataLoaded: false,
  isFetching: false,
  error: null,
  data: [],
};

export const getMedalStandingsDataAsync = createAsyncThunk(
  'medalStandings/fetchData',
  async (_, { dispatch, rejectWithValue, signal }) => {
    try {
      const response = await medalStandingsApi.fetchMedalStandingsData(signal);

      dispatch(pollingSucceeded());

      return response;
    } catch (err) {
      dispatch(pollingFailed({ sectionName: 'MedalStandings', error: err }));
      return rejectWithValue(err);
    }
  }
);

export const medalStandingsSlice = createSlice({
  name: 'medalStandingsSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMedalStandingsDataAsync.pending, state => {
        state.isFetching = true;
      })
      .addCase(getMedalStandingsDataAsync.fulfilled, (state, action) => {
        state.isFetching = false;
        state.dataLoaded = true;
        state.data = action.payload;
      })
      .addCase(getMedalStandingsDataAsync.rejected, (state, action) => {
        if (action.error.name !== 'AbortError') {
          state.isFetching = false;
          state.error = action.payload;
        }
      })
      .addCase(pollingErrorHandlerSlice.actions.clearPollingErrors, (state) => {
        state.error = null;
      });
  }
});

export const selectIsFetching = (state: RootState) => state.medalStandings.isFetching;
export const selectError = (state: RootState) => state.medalStandings.error;
export const selectDataLoaded = (state: RootState) => state.medalStandings.dataLoaded;
export const selectData = (state: RootState) => state.medalStandings.data;
export const selectChangeTimestamp = (state: RootState) => state.medalStandings.changeTimestamp;

export default medalStandingsSlice.reducer;